<template>
  <v-btn-toggle v-model="value" group :multiple="multiple" color="primary" @change="$emit('selectBtn',value)" :max="max">
    <v-btn
        v-for="n in total"
        :key="n-1"
        :min-width="minWidth"
        :value="str[n - 1]"
        active-class="active"
        plain
        :disabled="cmplt"
    >
      {{ str[n - 1]}}
    </v-btn>
  </v-btn-toggle>
</template>
<script>
export default {
  props: {
    total: Number,
    minWidth: Number,
    str: Array,
    max: Number,
    multiple: Boolean,
    selectedVal:Array,
    cmplt:Boolean,
  },
  data: () => ({
    value:[]
  }),
  watch: {
    value: {
        handler: function () {
          // console.log("this.value : ", this.value)
          // console.log("this.indexOf : ", this.value.indexOf("해당없음"))

          if(this.value.lastIndexOf("해당없음") > 0)  {
            this.value.splice(0, this.value.length)
            this.value.push("해당없음")
          }else if(this.value.indexOf("해당없음") == 0 && this.value.length > 1){
            this.value.splice(this.value.indexOf("해당없음"), 1);
          }
        },
        deep: true,
        immediate: true,
    },
  },
  created () {
    this.value = this.selectedVal
  },
}
</script>
<style lang="scss" scoped>
::v-deep.v-btn-toggle {
  flex-wrap: wrap;
  justify-content: center;
  max-width: 330px;

  > .v-btn.v-btn {
    border: 1px solid #D9D9D9 !important;
    border-radius: 6px;
    border-left-width: 1px !important;
    font-size: 16px;
    margin: 5px 8px;
    &.active {
      border-color: var(--v-primary-base) !important;
      box-shadow: 0px 2px 6px #00000029;
    }
  }
}
</style>
